import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";


function Resume() {
 

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href="https://drive.google.com/file/d/18z_yG2UD3rtYmG_8RDXMcINJ5qG-E9ry/view?usp=sharing" target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download Resume
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="Ast. Manager [New Delta Security and Support Sys.]"
              date="October 2017 - Present"
              content={[
                "Security Service Management.",
              ]}
              />
            <Resumecontent
              title="Web Developer [Freelancing]"
              date="February 2021 - Present"
              content={[
                "Assembled the data from various social media platforms using Twitter, Reddit.Interpreted the collected text using word-clouds and various other factors that affect the change of sentiments of youth.",
                " Utilized the data to find the issues using Topic Modelling and Building models using LSTM, BERT to predict the sentiments of the youth.",
              ]}
            />
            <h3 className="resume-title">Extracurricular Activities</h3>
            <Resumecontent
              title="Web Developer [2020- Present]"
              content={[
                "Worked on creating the frontend-end of the website using Bootstrap, Javascript, React, Node, MongoDB.",
              ]}
            />
            <Resumecontent
              title=" Volunteering[Leo Club Of Dhaka Kings Star]"
              content={[
                "Operated on developing Social Work and Others Volunteering ",
              ]}
            />
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="National University Bangladesh "
              date="2017 - Present"
             // content={[`CGPA: ${cgpa} (Till ${sem}th Sem)`]}
             content={[`CGPA:3.32 (4.00) Till:3rd Year`]}
            />
            <Resumecontent
              title="Govt.Niamatpur College,Naogaon"
              date="2016"
              exam="H.S.C (Science)"
              content={["CGPA:4.42-H.S.C (Science)"]}
            />
            <Resumecontent
              title="Mayamari T.L.B High School, Naogaon"
              date="2014"
              exam="S.S.C (Science)"
              content={["CGPA:5.00-S.S.C (Science)"]}
            />
            <h3 className="resume-title">Ranks and Achivements</h3>
            <Resumecontent
              title=""
              content={[
                `Current rank in Spoj :`,
                `Current rank in HackerRank : `,
                "Participant in Hack-A-Bit 2020",
              ]}
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href="https://drive.google.com/file/d/18z_yG2UD3rtYmG_8RDXMcINJ5qG-E9ry/view?usp=sharing" target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download Resume
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
